import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';

// Ignore a known benign browser ResizeObserver warning that can be raised
// by third-party components/layout updates during page transitions.
if (typeof window !== 'undefined') {
  window.addEventListener('error', (event) => {
    if (event?.message === 'ResizeObserver loop completed with undelivered notifications.') {
      event.stopImmediatePropagation();
    }
  });
}

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
